import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, DialogContent, Stack } from "@mui/material";
import { Box } from "@mui/system";
import { AlertsContext, DistaDialog, DistaDialogHeader } from "@sista/dista-ui";
import { useRequiredValidation, useSafeSistaAsync, } from "@sista/library-stasi";
import { useCallback, useContext } from "react";
import { useForm } from "react-hook-form";
import { FormContainer, SelectElement, TextFieldElement, } from "react-hook-form-mui";
import { useTranslation } from "react-i18next";
import { useSpravaTextuClient } from "../../util/useSpravaTextuClient";
export const EditNamespaceDialog = ({ namespace, onSuccess, onClose, }) => {
    const { t } = useTranslation("sprava-textu");
    const { showSuccess } = useContext(AlertsContext);
    const form = useForm({
        defaultValues: {
            namespace: namespace.namespace,
            format: namespace.format,
        },
    });
    const spratex = useSpravaTextuClient();
    const [updateNamespaceCall, updateNamespaceState] = useSafeSistaAsync(spratex.updateNamespace);
    const required = useRequiredValidation();
    const selectOptions = [
        {
            label: t("sprava-textu.admin.newNamespace.selectOpts.json", "json"),
            id: "JSON",
        },
        {
            label: t("sprava-textu.admin.newNamespace.selectOpts.properties", "properties"),
            id: "PROPERTIES",
        },
    ];
    const saveHandler = useCallback(async (data) => {
        const result = await updateNamespaceCall({
            namespace: namespace.namespace,
            newNamespaceName: data.namespace,
            format: data.format,
        });
        if (typeof result === "object" && result) {
            showSuccess(t("sprava-textu.admin.editNamespace.namespaceSaved", "Jmenný prostor uložen"));
            onSuccess?.();
        }
        onClose?.();
    }, [namespace, onClose, onSuccess, showSuccess, t, updateNamespaceCall]);
    return (_jsxs(DistaDialog, { open: true, onClose: onClose, children: [_jsx(DistaDialogHeader, { title: t("sprava-textu.admin.editNamespace.title", "Upravit jmenný prostor"), onClose: onClose }), _jsx(DialogContent, { children: _jsxs(FormContainer, { formContext: form, onSuccess: saveHandler, children: [_jsxs(Stack, { direction: "column", spacing: 2, sx: { my: 2 }, children: [_jsx(TextFieldElement, { name: "namespace", label: t("sprava-textu.admin.editNamespace.form.namespace", "Jmenný prostor"), validation: { ...required } }), _jsx(SelectElement, { name: "format", options: selectOptions, label: t("sprava-textu.admin.editNamespace.form.format", "Formát"), validation: { ...required } })] }), _jsxs(Stack, { direction: "row", spacing: 2, children: [_jsx(Box, { sx: { flexGrow: 1 } }), _jsx(Button, { variant: "contained", type: "submit", disabled: updateNamespaceState.pending, children: t("sprava-textu.admin.editNamespace.form.save", "Uložit") })] })] }) })] }));
};
